import { clsx } from "@trydig/ui";
import Image from "next/image";
import { Plus } from "~/components/icons/Plus";
import type { MappedColor } from "~/components/ui/VariantPicker";
import styles from "./ColorPicker.module.css";

export interface ColorPickerProps {
	colors: MappedColor[];
	onSelect: (color: MappedColor) => void;
}

export const ColorPicker = ({ colors, onSelect }: ColorPickerProps) => {
	return (
		<div className={styles.colors}>
			{colors?.map((color, i) => {
				return (
					<button
						className={clsx(
							styles.color,
							color.selected && styles.selected,
							color.soldOut && styles.soldOut,
						)}
						onClick={() => onSelect(color)}
						disabled={color.soldOut}
						key={color.color + i}
					>
						{color.image ? (
							<Image src={color.image} width={80} height={100} alt="Blue" />
						) : (
							<span className={styles.customContainer}>
								<Plus />
							</span>
						)}
						<div className={styles["color-info"]}>
							<p className={styles["variant-name"]}>{color.color}</p>
							{color.soldOut && <span className={styles.soldOutTag}>Utsolgt</span>}
						</div>
					</button>
				);
			})}
		</div>
	);
};
